<template>
  <div class="section-column section-content ">
      <div v-if="wordCounter" class="word-count-container h2" v-text="wordCounter">
      </div>
    <div class="word-bind-output-container disable-scrollbar">
      <a class="secondary-button copy-button" v-on:click="copyToClipBoard(wordList.map(d => d[1]))" >Copy Output</a>
        <div class="word-list-wrapper disable-scrollbar">
          <div class="word-list disable-scrollbar" v-for="item in wordList.slice(0)" :key="item.id">
              {{item[1]}}
          </div>
        </div>
    </div>
    <a class="primary-button" v-on:click="exportToCsv('wordList.csv', wordList)" >Download Results as CSV</a>
  </div>
</template>

<script>

export default {
  name: 'WordBind',
  props: {
    wordColumnA: {
      type: String,
    },
    wordColumnB: {
      type: String,
    },
    wordColumnC: {
      type: String,
    },
  },
  data() {
    return {
      wordArray: false,
      wordCount: '',
    };
  },
  computed: {
    wordList() {
      const wordSeperator = [' '];
      // Split word columns into an array by line
      let firstWords = this.wordColumnA.toLowerCase().split('\n');
      let secondWords = this.wordColumnB.toLowerCase().split('\n');
      let thirdWords = this.wordColumnC.toLowerCase().split('\n');

      // Remove empty lines/values from the array
      firstWords = firstWords.filter(col => col);
      secondWords = secondWords.filter(col => col);
      thirdWords  = thirdWords.filter(col => col);

      // Force in a new line at the end to retrieve all possible combinations
      if (firstWords.at(-1) != '' && secondWords[0] != '') {
          firstWords.push('');
      }

      if (thirdWords.at(-1) != '' && secondWords[0] != '') {
          thirdWords.push('');
      }

      this.wordArray = [firstWords, wordSeperator, secondWords, wordSeperator, thirdWords];
      this.wordArray = this.combineArrays(this.wordArray);
      return this.wordArray;
    },
    wordCounter() {
      if (!this.wordColumnA && !this.wordColumnB && !this.wordColumnC) return;
      this.wordCount = this.wordArray.length;
      if (this.wordCount < 1) return;
      let suffix = '';
      if (this.wordCount === 1) {
        suffix = 'Combination'
      } else {
        suffix = 'Combinations'
      }
      return `${this.wordCount} ${suffix}`;
    },
  },
  methods: {
    combineArrays(arrayOfArrays) {
      // First, handle some degenerate cases...

      if (!arrayOfArrays) {
        // Or maybe we should toss an exception...?
        return [];
      }

      if (!Array.isArray(arrayOfArrays)) {
        // Or maybe we should toss an exception...?
        return [];
      }

      if (arrayOfArrays.length === 0) {
        return [];
      }

      for (let i = 0; i < arrayOfArrays.length; i++) {
        if (!Array.isArray(arrayOfArrays[i]) || arrayOfArrays[i].length === 0) {
          // If any of the arrays in arrayOfArrays are not arrays or zero-length, return an empty array...
          return [];
        }
      }

      // Done with degenerate cases...

      // Start "odometer" with a 0 for each array in arrayOfArrays.
      const odometer = new Array(arrayOfArrays.length);
      odometer.fill(0);

      const output = [];
      let newCombination = this.formCombination(odometer, arrayOfArrays);

      output[0] = [0, newCombination];
      let $i = 1;
      while (this.odometer_increment(odometer, arrayOfArrays)) {
        newCombination = this.formCombination(odometer, arrayOfArrays);
        output[$i] = [$i, newCombination];
        $i++;
      }

      return output;
    },
    /* combineArrays() */
    // Translate "odometer" to combinations from arrayOfArrays
    formCombination(odometer, arrayOfArrays) {
      // In Imperative Programmingese (i.e., English):
      // let s_output = "";
      // for( let i=0; i < odometer.length; i++ ){
      //    s_output += "" + arrayOfArrays[i][odometer[i]];
      // }
      // return s_output;

      // In Functional Programmingese (Henny Youngman one-liner):
      return odometer.reduce(
        (accumulator, odometerValue, odometerIndex) => `${accumulator}${arrayOfArrays[odometerIndex][odometerValue]}`,
        '',
      );
    },
    /* formCombination() */
    odometer_increment(odometer, arrayOfArrays) {
      // Basically, work you way from the rightmost digit of the "odometer"...
      // if you're able to increment without cycling that digit back to zero,
      // you're all done, otherwise, cycle that digit to zero and go one digit to the
      // left, and begin again until you're able to increment a digit
      // without cycling it...simple, huh...?

      for (let iOdometerDigit = odometer.length - 1; iOdometerDigit >= 0; iOdometerDigit--) {
        const maxee = arrayOfArrays[iOdometerDigit].length - 1;

        if (odometer[iOdometerDigit] + 1 <= maxee) {
          // increment, and you're done...
          odometer[iOdometerDigit]++;
          return true;
        }

        if (iOdometerDigit - 1 < 0) {
          // No more digits left to increment, end of the line...
          return false;
        }

        // Can't increment this digit, cycle it to zero and continue
        // the loop to go over to the next digit...
        odometer[iOdometerDigit] = 0;
        continue;
      }/* for( let odometer_digit = odometer.length-1; odometer_digit >=0; odometer_digit-- ) */
    }/* this.odometer_increment() */,
    exportToCsv(filename, rows) {
      const processRow = function (row) {
        let finalVal = '';
        for (let j = 0; j < row.length; j++) {
          let innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          let result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = `"${result}"`;
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return `${finalVal}\n`;
      };

      let csvFile = '';
      for (let i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    copyToClipBoard(textToCopy){
      console.log(textToCopy);
      let text = '';

      for (let i = 0; i < textToCopy.length; i++) {
        text += textToCopy[i].trim() + "\n";
      }

      const tmpTextField = document.createElement("textarea");
      tmpTextField.textContent = text;
      tmpTextField.setAttribute("style","position:absolute; right:200%;");
      document.body.appendChild(tmpTextField);
      tmpTextField.select();
      tmpTextField.setSelectionRange(0, 99999);/*For mobile devices*/
      document.execCommand("copy");
      tmpTextField.remove();
    },
  },
};
</script>

<style lang="scss" scoped>
a {
    cursor: pointer;
    display: flex !important;
}

.word-bind-output-container {
    max-height: 300px;
    height: 300px;
    overflow: scroll;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: baseline;
}

.disable-scrollbars {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */

  &::-webkit-scrollbar {
    background: transparent; /* Chrome/Safari/Webkit */
    width: 0px;
  }
}
</style>
